import React from "react";
import { useTranslation } from "react-i18next";
import { ProductDashboard } from "@core/components/products/dashboard/ProductDashboard";
import { ProductSidebar } from "@core/components/layout/products/ProductSidebar";
import { ProductHeader } from "@core/components/layout/products/ProductHeader";
import { AuthRequired } from "@core/components/AuthRequired";
import { SEOHead } from "../components/SEOHead";

const DatePollsDashboard: React.FC = () => {
  const { t } = useTranslation("common");
  return (
    <>
      {/* Hors AuthRequired : le titre doit être posé même avant connexion */}
      <SEOHead title={t("seo_title_dashboard")} noIndex />
      <AuthRequired
        header={<ProductHeader productType="date" showAuth={true} />}
      >
        <div className="min-h-screen-safe bg-gray-50">
          {/* Barre haute avec connexion */}
          <ProductHeader productType="date" showAuth={true} />

          {/* Contenu principal avec sidebar */}
          <div className="flex">
            {/* Sidebar auto-suffisante avec son hamburger */}
            <ProductSidebar productType="date" />

            {/* Contenu principal */}
            <div className="flex-1">
              <ProductDashboard productType="date" />
            </div>
          </div>
        </div>
      </AuthRequired>
    </>
  );
};

export default DatePollsDashboard;
